import { SocieteDto } from "../../dto/GenApi.iNotPaie.Dto/SocieteDto";
import { EventBus } from "./EventBus";
import EventConstants from "./EventConstants";
import { ServicesFactoryInstance } from "./ServicesFactory";


export class LicensingManager {
    public listActiveLicenses?: string[] = undefined;


    public constructor() {
        EventBus.$on(EventConstants.SOCIETE_CHANGED, (data) => this.getLicensesActive(data));

    }

    public getLicensesActive(societe: SocieteDto): void {

        if (societe.NoIcare != undefined) {
            ServicesFactoryInstance.LicensingService.getLicensesActive(
                societe.NoIcare,
                (data) => {
                    this.listActiveLicenses = data;
                    EventBus.$emit(EventConstants.LICENSES_LOADED);
                },
                (error) => {
                    this.listActiveLicenses = undefined;
                    EventBus.$emit(EventConstants.LICENSES_LOADED);
                }
            );
        } else {
            EventBus.$emit(EventConstants.LICENSES_LOADED);
        }
    }

    public hasLicense(license: string): boolean {

        return this.listActiveLicenses != undefined && this.listActiveLicenses.filter(r => r == license).length > 0
    }

}

export const LicensingManagerInstance: LicensingManager = new LicensingManager();



// WEBPACK FOOTER //
// ./src/components/Controls/LicensingManager.ts